// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let PayorV4Api = class PayorV4Api {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @summary Get Medical Benefits by Account identifier.
     * @param accountId Account identifier
     */
    async accountMedicalGet1(accountId) {
        const _url_ = '/payor/v4/AccountMedical/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountMedicalGet1.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountMedicalBenefitModels");
        }
        return response;
    }
    /**
     *
     * @summary Get Medical Benefits by Account and Payor identifiers.
     * @param accountId Account identifier
     * @param payorId Payor identifier
     */
    async accountMedicalGet2(accountId, payorId) {
        const _url_ = '/payor/v4/AccountMedical/{accountId}/{payorId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountMedicalGet2.');
        }
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling accountMedicalGet2.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountMedicalBenefitModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get existing Pharmacy Benefits by Account identifier.
     * @param accountId Account identifier
     */
    async accountPharmacyGet1(accountId) {
        const _url_ = '/payor/v4/AccountPharmacy/{accountId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPharmacyGet1.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountPharmacyBenefitModels");
        }
        return response;
    }
    /**
     *
     * @summary Get an existing Pharmacy Benefit by Account and Payor identifiers.
     * @param accountId Account identifier
     * @param payorId Payor identifier
     */
    async accountPharmacyGet2(accountId, payorId) {
        const _url_ = '/payor/v4/AccountPharmacy/{accountId}/{payorId}'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)))
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'accountId' is not null or undefined
        if (accountId === null || accountId === undefined) {
            throw new Error('Required parameter accountId was null or undefined when calling accountPharmacyGet2.');
        }
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling accountPharmacyGet2.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorAccountPharmacyBenefitModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Create a new Payor.
     * @param payorSaveModel Model containing the details to save
     */
    async payorCreateByTenantId(payorSaveModel) {
        const _url_ = '/payor/v4/Payor';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorSaveModel' is not null or undefined
        if (payorSaveModel === null || payorSaveModel === undefined) {
            throw new Error('Required parameter payorSaveModel was null or undefined when calling payorCreateByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorSaveModel, "PayorSaveModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorLongResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get an existing Payor by Tenant and Payor identifiers
     * @param payorId Payor identifier
     */
    async payorGetByTenantId(payorId) {
        const _url_ = '/payor/v4/Payor/{payorId}'
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling payorGetByTenantId.');
        }
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get existing Payor Plans by Tenant identifier and list of Payor identifiers.
     * @param payorPlanListRequestModel PayorPlanListRequestModel object
     */
    async payorPlanListByTenantId(payorPlanListRequestModel) {
        const _url_ = '/payor/v4/PayorPlanList';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorPlanListRequestModel' is not null or undefined
        if (payorPlanListRequestModel === null || payorPlanListRequestModel === undefined) {
            throw new Error('Required parameter payorPlanListRequestModel was null or undefined when calling payorPlanListByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorPlanListRequestModel, "PayorPlanListRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorPlanModels");
        }
        return response;
    }
    /**
     *
     * @summary Search for an existing Payor.
     * @param payorSearchModel PayorSearchModel object
     */
    async payorSearchByTenantId(payorSearchModel) {
        const _url_ = '/payor/v4/PayorSearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorSearchModel' is not null or undefined
        if (payorSearchModel === null || payorSearchModel === undefined) {
            throw new Error('Required parameter payorSearchModel was null or undefined when calling payorSearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorSearchModel, "PayorSearchModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorSearchModelResponse");
        }
        return response;
    }
    /**
     *
     * @summary Update an existing Payor.
     * @param payorId Payor identifier
     * @param payorSaveModel Model containing the details to save
     */
    async payorUpdateByTenantId(payorId, payorSaveModel) {
        const _url_ = '/payor/v4/Payor/{payorId}'
            .replace('{' + 'payorId' + '}', encodeURIComponent(String(payorId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'payorId' is not null or undefined
        if (payorId === null || payorId === undefined) {
            throw new Error('Required parameter payorId was null or undefined when calling payorUpdateByTenantId.');
        }
        // verify required parameter 'payorSaveModel' is not null or undefined
        if (payorSaveModel === null || payorSaveModel === undefined) {
            throw new Error('Required parameter payorSaveModel was null or undefined when calling payorUpdateByTenantId.');
        }
        let requestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(payorSaveModel, "PayorSaveModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorResponseModel");
        }
        return response;
    }
    /**
     *
     * @summary Upsearch Payor
     * @param upsearchModelPayorPayorUpsearchModel PayorUpsearchModel object
     */
    async payorUpsearchByTenantId(upsearchModelPayorPayorUpsearchModel) {
        const _url_ = '/payor/v4/PayorUpsearch';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'upsearchModelPayorPayorUpsearchModel' is not null or undefined
        if (upsearchModelPayorPayorUpsearchModel === null || upsearchModelPayorPayorUpsearchModel === undefined) {
            throw new Error('Required parameter upsearchModelPayorPayorUpsearchModel was null or undefined when calling payorUpsearchByTenantId.');
        }
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(upsearchModelPayorPayorUpsearchModel, "UpsearchModelPayorPayorUpsearchModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorLongResponse");
        }
        return response;
    }
    /**
     *
     * @summary Get Plan Types
     */
    async planTypeGet() {
        const _url_ = '/payor/v4/PlanType';
        let _params_ = {};
        let _headers_ = {};
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PayorRoleTypeModels");
        }
        return response;
    }
};
PayorV4Api = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], PayorV4Api);
export { PayorV4Api };
//# sourceMappingURL=payorV4Api.js.map